import { injectable } from "tsyringe";
import { PusatResolusiV2ApiRepository } from "@/app/infrastructures/repositories/api/PusatResolusiV2ApiRepository";
import {
  CheckTicketPusatResolusiRequest,
  FinishIssuePusatResolusiV2Request,
  ListTicketPusatResolusiRequest,
  SendChatPusatResolusiRequest,
  SubmitNotePusatResolusiRequest,
  GetConversationRequest,
  ListSTTPusatResolusi,
  TicketCounterPusatResolusiRequest,
  SubmitFeedbackApiRequest,
  FollowTicketApiRequest,
  AddTemplatePusatResolusiRequest,
  GetTicketActionRequest,
  DownloadLaporanRequest,
  CheckCategoryPusatResolusiRequest,
  ReopenPusatResolusiV2Request
} from "@/data/payload/api/PusatResolusiV2ApiRequest";
import {
  CategoryPusatResolusi,
  TicketCounterPusatResolusi,
  CheckIssuePusatResolusi,
  TicketListItem,
  TicketPusatResolusiDetail,
  PusatResolusiSTTData,
  BulkDownload
} from "@/domain/entities/PusatResolusiV2";
import { ApiRequestList } from "@/domain/entities/MainApp";

@injectable()
export class PusatResolusiV2Presenter {
  private repository: PusatResolusiV2ApiRepository;

  constructor(repository: PusatResolusiV2ApiRepository) {
    this.repository = repository;
  }

  checkTicket(
    params: CheckTicketPusatResolusiRequest
  ): Promise<TicketPusatResolusiDetail> {
    return this.repository.checkTicket(params);
  }

  checkCategory(payload: CheckCategoryPusatResolusiRequest) {
    return this.repository.checkCategory(payload);
  }

  getListCategory(
    params: CheckTicketPusatResolusiRequest
  ): Promise<CategoryPusatResolusi[]> {
    return this.repository.getListCategory(params);
  }

  getTicketCounter(params: TicketCounterPusatResolusiRequest): Promise<TicketCounterPusatResolusi> {
    return this.repository.getTicketCounter(params);
  }

  getListTicket(
    params: ListTicketPusatResolusiRequest
  ) {
    return this.repository.getListTicket(params);
  }

  getSTTList(params: ListSTTPusatResolusi): Promise<PusatResolusiSTTData> {
    return this.repository.getSTTList(params);
  }


  checkIssue(
    params: CheckTicketPusatResolusiRequest
  ): Promise<CheckIssuePusatResolusi> {
    return this.repository.checkIssue(params);
  }

  checkIssueV2(
    params: CheckTicketPusatResolusiRequest
  ): Promise<TicketListItem[]> {
    return this.repository.checkIssueV2(params);
  }

  followTicket(payload: FollowTicketApiRequest) {
    return this.repository.followTicket(payload);
  }

  finishIssue(id: number, payload: FinishIssuePusatResolusiV2Request) {
    return this.repository.finishIssue(id, payload);
  }
  reopenIssue(id: number, payload: ReopenPusatResolusiV2Request) {
    return this.repository.reopenIssue(id, payload);
  }
  getTicketDetail(id: number) {
    return this.repository.getTicketDetail(id);
  }

  getTicketAction(id: number, params: GetTicketActionRequest) {
    return this.repository.getTicketAction(id, params);
  }

  submitNote(payload: SubmitNotePusatResolusiRequest): Promise<boolean> {
    return this.repository.submitNote(payload);
  }

  create(
    payload: CheckTicketPusatResolusiRequest
  ): Promise<TicketPusatResolusiDetail> {
    return this.repository.create(payload);
  }

  getMentionData(id: number) {
    return this.repository.getMention(id);
  }

  sendChat(id: number, payload: SendChatPusatResolusiRequest) {
    return this.repository.sendChat(id, payload);
  }

  getConversation(id: number, params: GetConversationRequest) {
    return this.repository.getConversation(id, params);
  }

  getTemplateChat() {
    return this.repository.getTemplateChat();
  }

  connectConversationWebsocket(id: number): WebSocket {
    return this.repository.connectConversationWebsocket(id);
  }

  submitFeedback(
    id: number,
    payload: SubmitFeedbackApiRequest
  ): Promise<boolean> {
    return this.repository.submitFeedback(id, payload);
  }

  addTemplate(payload: AddTemplatePusatResolusiRequest): Promise<boolean> {
    return this.repository.addTemplate(payload);
  }

  requestDownloadLaporan(payload: DownloadLaporanRequest): Promise<boolean> {
    return this.repository.requestDownloadLaporan(payload);
  }
  getBulkDownload(params: ApiRequestList): Promise<BulkDownload> {
    return this.repository.getBulkDownload(params);
  }

  checkTicketV2(
    params: CheckTicketPusatResolusiRequest
  ): Promise<TicketPusatResolusiDetail[]> {
    return this.repository.checkTicketV2(params);
  }
}
